import React, { useContext, useState, useEffect } from 'react';
import { SettingsBannerContext } from '../../contexts/SettingsBannerContext';
import { MasterBannerContext } from '../../contexts/MasterBannerContext';
import Elements from './Elements/index';
import './index.css';
import Divider from '@mui/material/Divider';
import Button from '../Button';
import { useAuth } from '../../hooks/useAuth'
import { BannerJson } from '../../helpers/buildBanner';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
// import toast, { Toaster } from 'react-hot-toast';

function Preset() {
  const { recordHash } = useAuth();
  const { setReload, setLoading, setVideoModal, stepActive, setStepActive, fullScreenLeft, fullScreenRight, setError } = useContext(SettingsBannerContext);
  const { master, setMaster } = useContext(MasterBannerContext);
  const  [newTime, setNewTime] =  useState('');
  const  [inputValue, setInputValue] = useState('')

  const barStep = [];
  const barStepColor = ["#AE56A5", "#E28F57", "#E55581", "#7DE5B8", "#1B9ADA", "#e1eb34", "#e1eb34", "#eba534"];
  let arraySteps = [];

  const stepActiveTotalTime = (index,barStep, arrStepTime) =>{
    let arrTimes = []
    for(let i = index; i < barStep.length; i++) {
      arrTimes.push(arrStepTime[i]); 
    }
    const initialValue = 0;
    const totalActiveStepTime = arrTimes.reduce( (accumulator, currentValue) => accumulator + currentValue, initialValue);
    let total = totalActiveStepTime.toFixed(1)
    return total
  }

  function activeStep (index, arrStepTime, barStep){
    let time = arrStepTime.map((a) => parseFloat(a.toFixed(1)));
    let step = `step ${index + 1}`;

    const activeStepInfo = {
      name: step,
      position: index,
      duration: time[index],
      stepPosition: index + 1,
      tillTheEnd: false
    };

    if (stepActive && index === stepActive.position) {
      if (stepActive.tillTheEnd === false && (stepActive.position !== 1 || stepActive.position < barStep.length)) {
        activeStepInfo.tillTheEnd = true;
        activeStepInfo.duration = stepActiveTotalTime(index,barStep, arrStepTime)
        setStepActive(activeStepInfo);
      } else {
        setStepActive(null);
      }
      return;
    } else {
      setStepActive(activeStepInfo);
    }

  };

  try {
      
    const steps = master.elements[master.elements.length - 1].step;
    if (steps === 1) {
      barStep.push("100");
      barStepColor.push("100");
    } else {
      for (let i = 1; i <= steps; i++) {
        let time = 0;
        master.elements.forEach(element => {
          if (element.step === i) {
            const delay = parseFloat(element.animation.in.delay);
            if (delay > 0) time += delay;
            if (element.step !== steps) {
              const delay = parseFloat(element.animation.out.delay);
              if (delay > 0) time += delay;
            }
          }
        });
        if (i === steps) {
          time += master.elements[master.elements.length - 1].animation.in.duration / 1000;
        }
        
        arraySteps.push(time);
      } 
      const totalDelay = () => {
        var total = 0;
        arraySteps.forEach((item, index) => {
          if (index < steps) total += item;
        });
        return total;
      }
  
      arraySteps.forEach(item => {
        barStep.push(((parseFloat(item) / totalDelay()) * 100).toFixed(2));
      });

    }
  } catch (error) {}

  function ChangeLoop(value) {
    var masterCopy = JSON.parse(JSON.stringify(master));
    if (masterCopy.loop < 5 && value === 1) masterCopy.loop += value;
    else if (masterCopy.loop === 5 && value === 1) masterCopy.loop = 100000;
    else if (masterCopy.loop > 5 && value === 1) masterCopy.loop = 1;
    setMaster(masterCopy);
    setReload(true);
  }

  let duration = master && master.duration ? master.duration.toFixed(1) : "-"

  const [divWidth, setDivWidth] = useState('100%')

  useEffect(() => {
    function handleResize() {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 1280 && windowWidth <= 1359) {
        if (fullScreenLeft && fullScreenRight) {
          setDivWidth('102.3%');
        } else if (fullScreenLeft) {
          setDivWidth('102.9%');
        } else if (fullScreenRight) {
          setDivWidth('103%');
        } else {
          setDivWidth('104.1%');
        }
      } else if (windowWidth >= 1360) {
        setDivWidth('100%');
      } 
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenLeft, fullScreenRight]);

  function setNewBannerTime(newTimeValue) {
    if(inputValue < 3 ){
      setError(
        { mensagem: "Insira um valor a partir de 3s",
          lista: [],
          show: true
        }
      );
      setInputValue('')
      return
     }
     newTimeValue.trim()
     newTimeValue = parseFloat(newTimeValue);
    var masterCopy = JSON.parse(JSON.stringify(master));
    newTimeValue =  newTimeValue - masterCopy.elements[masterCopy.elements.length - 1].animation.in.duration / 1000;
    let duration = masterCopy.duration - masterCopy.elements[masterCopy.elements.length - 1].animation.in.duration / 1000;

    const steps = masterCopy.elements[masterCopy.elements.length - 1].step;
  
    let percent = (((newTimeValue / duration) * 100) - 100).toFixed(2);

    const incDecPercentagem = (number, percentage) => {
      return (number * (1 + percentage / 100));
    };  
  
    const times = [];
    arraySteps = []

    for (let i = 1; i <= steps; i++) {
      let time = 0;
      masterCopy.elements.forEach(element => {
        if (element.step === i) {
          let delay = parseFloat(element.animation.in.delay);
          let newDelay = incDecPercentagem(delay, percent);
          newDelay = parseFloat(newDelay.toPrecision(2));

          if (delay > 0){
            time += newDelay
            times.push(newDelay);
            element.animation.in.delay = newDelay;
          } 
  
          if (element.step !== steps) {
            let delayOut = parseFloat(element.animation.out.delay);
            let newDelayOut = incDecPercentagem(delayOut, percent);
            newDelayOut = parseFloat(newDelayOut.toFixed(1));
            if (delayOut > 0){
              time += newDelayOut;
              times.push(newDelayOut);
              newDelayOut.toString();
              element.animation.out.delay = newDelayOut;
            }
           
          }
        }
      });
  
      if (i === steps) {
        time += master.elements[master.elements.length - 1].animation.in.duration / 1000;
        times.push(master.elements[master.elements.length - 1].animation.in.duration / 1000);
      }

    arraySteps.push(time);
    setInputValue('')
    setMaster(masterCopy)
    }
  }

	return (
<>
  <div className='container-preset'>
    <Divider style={{ width: '100%', opacity: '10%'}}/>
    <div className='containerTimeline'>
      <div className='dynamicTimeline'>
        {barStep.map((item, index) =>
          <div
            onClick={() => barStep.length > 1 ? activeStep(index, arraySteps, barStep)  : ''}
            className={(stepActive && index === stepActive.position) || (stepActive && stepActive.tillTheEnd === true && index >= stepActive.position) ? "stripe" : "step"}
            key={Math.random()}
            style={{
              cursor: 'pointer',
              width: item + '%',
              height: '100%',
              backgroundColor: barStepColor[index],
              borderRadius:
                barStepColor.length === 1 ? '25px 25px 25px 25px' : index === 0 ?
                 '25px 0px 0px 25px' : index === barStepColor.length - 1 ?
                 '0px 25px 25px 0px' : '0px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
          }}>
            <span style={{color: 'white', fontSize: '14px', fontWeight: 'bold', textShadow: '2px 2px 1px rgba(0,0,0,0.8)'}}>S{index + 1}</span>
          </div>
        )}
      </div>
      <div className='playButtonAndLoop'>
        <PlayCircleIcon onClick={() => setReload(true)} style={{color: '#1B9ADA', margin: '0 5px 0 30px', width: '28px', height: '28px', cursor: 'pointer'}} />
        <span style={{fontWeight: 'bold', fontSize: '15px'}}>
        {stepActive === null ? 
        <input type="number"
        value={inputValue}
        name='newTime'
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.target.blur();
            setNewBannerTime(inputValue);
          }
        }}
        onBlur={() => setInputValue('')}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={`${duration}s`}
        // onBlur={() => setNewBannerTime(inputValue)}
        className="step-time-input"
        />
        : 
        stepActive.duration }
        </span>
        <div style={{display: 'flex', height: '22px', justifyContent: 'center', alignItems: 'center', width: '80px', margin: '0 0px 0 10px'}}>
          <AllInclusiveIcon style={{width: '30px', height: '30px', margin: '0 10px 0 0', cursor: 'pointer'}} onClick={() => ChangeLoop(1)} />
          <span style={{fontWeight: 'bold', fontSize: '15px'}}>{ master.loop < 6 ? master.loop + "x" : <>&#8734;</> }</span>
        </div>
      </div>
    </div>
    <div className='containerElements' style={{width: divWidth}}>
      <div style={{minWidth:  '100%', justifyContent: 'space-between', height: '230px', borderRadius: '10px', display: 'flex', alignItems: 'center', marginTop: '10px'}}>
        <Elements/>
      </div>
    </div>
  </div>
  </>
	)
}

export default Preset;